<template>
    <div>
        <!-- 搜索区域 -->
        <global-tag>
            <span slot="title">监控管理</span>
            <div class="search" slot="search">
                <el-form :model="queryInfo" label-width="90px">
                    <el-row type="flex" justify="start">
                        <el-col :span="6">
                            <el-form-item label="所属模块:">
                                <el-cascader
                                    style="width: 100%"
                                    :key="isRescourceShow"
                                    :options="options"
                                    v-model="queryInfo.flag"
                                    
                                    :show-all-levels="false"
                                    :props="{
                                        emitPath: false,
                                        label: 'label',
                                        value: 'value',
                                    }"
                                    clearable
                                >
                                </el-cascader>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-button type="primary" @click="QuerySearch" size="medium" class="searchBtns" style="height: 40px; margin-left: 5%;"
                                >查询
                            </el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </global-tag>
        <!-- 表格主体区域 -->
        <div>
            <!-- 新增按钮,下拉 -->
            <div class="btn_group">
                <div>
                    <el-button-group>
                        <el-button
                            type="success"
                            icon="iconfont icon-xinzeng"
                            class="openBtns"
                            @click="showDialog('新增')"
                            >新增
                        </el-button>
                    </el-button-group>
                </div>
                <el-button-group>
                    <el-button
                        type="primary"
                        icon="el-icon-refresh"
                        class="dropRests"
                        @click="Reset"
                    ></el-button>
                    <!-- <el-button type="primary" style="padding: 10px 20px"> -->
                    <el-dropdown
                        class="dropdown1"
                        trigger="click"
                        :hide-on-click="false"
                    >
                        <span class="el-dropdown-link">
                            <i
                                class="el-icon-s-grid el-icon--right"
                                style="color: #fff"
                            ></i>
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu
                            slot="dropdown"
                            class="table_checkbox"
                        >
                            <el-dropdown-item>
                                <el-checkbox-group
                                    v-model="tableChekbox"
                                    @change="tableChekboxChange"
                                >
                                    <el-checkbox label="序号"></el-checkbox>
                                    <br />
                                    <el-checkbox label="所属机构"></el-checkbox>
                                    <br />
                                    <el-checkbox label="所属模块"></el-checkbox>
                                    <br />
                                    <el-checkbox label="萤石云key"></el-checkbox>
                                    <br />
                                    <el-checkbox label="萤石云secret"></el-checkbox>
                                    <br />
                                    <el-checkbox label="序列"></el-checkbox>
                                    <br />
                                    <el-checkbox label="通道"></el-checkbox>
                                    <br />
                                    <el-checkbox label="操作"></el-checkbox>
                                    <br />
                                </el-checkbox-group>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <!-- </el-button> -->
                </el-button-group>
            </div>
            <!-- 表格 -->
            <div>
                <el-table
                    :data="tableData"
                    border
                    style="width: 100%"
                    :header-cell-style="{
                        background: '#f2f2f2',
                        color: '#000',
                    }"
                >
                    <el-table-column
                        type="index"
                        label="序号"
                        width="80"
                        align="center"
                        v-if="
                            this.tempTableChekbox.findIndex(
                                (item) => item == '序号'
                            ) != -1
                        "
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="orgIdName"
                        label="所属机构"
                        align="center"
                        v-if="
                            this.tempTableChekbox.findIndex(
                                (item) => item == '所属机构'
                            ) != -1
                        "
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="flag"
                        label="所属模块"
                        align="center"
                        v-if="
                            this.tempTableChekbox.findIndex(
                                (item) => item == '所属模块'
                            ) != -1
                        "
                        :show-overflow-tooltip="true"
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.flag == 1">监管平台</span>
                            <span v-if="scope.row.flag == 2">监管地图</span>
                            <span v-if="scope.row.flag == 3">消防安全</span>
                            <span v-if="scope.row.flag == 4">客服中心</span>
                            <span v-if="scope.row.flag == 5">话务监管</span>
                            <span v-if="scope.row.flag == 6">客服中心可视化</span>
                            <span v-if="scope.row.flag == 7">社区养老</span>
                            <span v-if="scope.row.flag == 8">机构养老</span>
                            <!-- <span v-if="scope.row.flag == 9">机构养老</span> -->
                            <span v-if="scope.row.flag == 10">就餐信息可视化</span>
                            <span v-if="scope.row.flag == 11">机构养老一张图</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="ysyKey"
                        label="萤石云key"
                        align="center"
                        v-if="
                            this.tempTableChekbox.findIndex(
                                (item) => item == '萤石云key'
                            ) != -1
                        "
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="ysySecret"
                        label="萤石云secret"
                        align="center"
                        v-if="
                            this.tempTableChekbox.findIndex(
                                (item) => item == '萤石云secret'
                            ) != -1
                        "
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>

                    <el-table-column
                        prop="sequence"
                        label="序列"
                        align="center"
                        v-if="
                            this.tempTableChekbox.findIndex(
                                (item) => item == '序列'
                            ) != -1
                        "
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column><el-table-column
                        prop="channel"
                        label="通道"
                        width="80"
                        align="center"
                        v-if="
                            this.tempTableChekbox.findIndex(
                                (item) => item == '通道'
                            ) != -1
                        "
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        width="300"
                        align="center"
                        v-if="
                            this.tempTableChekbox.findIndex(
                                (item) => item == '操作'
                            ) != -1
                        "
                    >
                        <template slot-scope="scope">
                            <el-row type="flex" justify="start">
                                <el-col :span="7">
                                    <el-link
                                        :underline="false"
                                        @click="showDialog('查看', scope.row)"
                                        >查看
                                    </el-link>
                                </el-col>
                                <el-col :span="7">
                                    <el-link
                                        :underline="false"
                                        @click="showDialog('编辑', scope.row)"
                                        >编辑
                                    </el-link>
                                </el-col>
                                <el-col :span="7">
                                    <el-link
                                        :underline="false"
                                        @click="deleteItem(scope.row)"
                                        >删除
                                    </el-link>
                                </el-col>
                            </el-row>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 分页 -->
            <div class="bottom-page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 40, 100]"
                    :page-size="query.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                >
                </el-pagination>
            </div>
        </div>
        <!-- 弹框 -->
        <!-- 新增,查看,编辑弹框 -->
        <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            width="590px"

            @close="dialogVisibleClone"
        >
            <el-form
                ref="addformRef"
                :rules="formDateRules"
                :model="addForm"
                label-width="110px"
                :disabled="dialogTitle == '查看'"
            >
                <el-form-item label="所属机构:" prop="orgId">
                    <el-cascader
                        style="width: 100%"
                        :key="isRescourceShow"
                        :options="orgTree"
                        v-model="addForm.orgId"
                        :show-all-levels="false"
                        :props="{
                            checkStrictly: true,
                            emitPath: false,
                            label: 'label',
                            value: 'orgId',
                        }"
                        clearable
                    >
                    </el-cascader>
                </el-form-item>
                <el-form-item label="所属模块:" prop="flag">
                    <el-cascader
                        style="width: 100%"
                        :key="isRescourceShow"
                        :options="options"
                        v-model="addForm.flag"
                        
                        :show-all-levels="false"
                        :props="{
                            emitPath: false,
                            label: 'label',
                            value: 'value',
                        }"
                        @change="flagChang(addForm.flag)"
                        clearable
                    >
                    </el-cascader>
                    <!-- checkStrictly: true, -->
                    <!-- <el-select v-model="addForm.flag" style="width:100%" clearable>
                        <el-option value="1" label="监管平台"></el-option>
                        <el-option value="2" label="养老服务"></el-option>
                    </el-select> -->
                </el-form-item>
                <el-form-item label="萤石云key:" prop="ysyKey">
                    <el-input  v-model="addForm.ysyKey" style="width:100%" clearable></el-input>
                </el-form-item>
                <el-form-item label="萤石云secret:" prop="ysySecret">
                    <el-input  v-model="addForm.ysySecret" style="width:100%" clearable></el-input>
                </el-form-item>
                <el-form-item label="序列:" prop="sequence">
                    <el-input  v-model="addForm.sequence" style="width:100%" clearable></el-input>
                </el-form-item>
                <el-form-item label="通道:" prop="channel">
                    <el-input  v-model="addForm.channel" style="width:100%" clearable></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer btnSite">
                <el-button size="small" type="primary" @click="send" v-if="dialogTitle != '查看'" >确 定</el-button>
                <el-button size="small" @click="dialogVisibleClone">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import globalTag from "../../components/globalTag"
import request from "@/utils/request.js"

export default {
    name: "ItemManagement",
    components: {
        globalTag,
    },
    data() {
        return {
            formDateRules: {
                orgId: [
                    { required: true, message: "请选择所属机构", trigger: "blur" },
                ], // 
                flag: [
                    {
                        required: true,
                        message: "请选择所属模块",
                        trigger: "blur",
                    },
                ], // 
                ysyKey: [
                    { required: true, message: "请输入萤石云key", trigger: "blur" },
                ], 
                ysySecret: [
                    { required: true, message: "请输入萤石云secret", trigger: "blur" },
                ], 
                sequence: [
                    { required: true, message: "请输入序列", trigger: "blur" },
                ], 
                channel: [
                    { required: true, message: "请输入通道", trigger: "blur" },
                ], 
            },
            dialogTitle: "", // 新增,查看,编辑弹框标题
            dialogVisible: false, // 新增,查看,编辑弹框的显示与隐藏
            actionUrl: "", // 图片上传地址
            // 查询信息
            queryInfo: {},
            query: {
                pageNo: 1,
                pageSize: 10,
            },
            total: 0,
            orgTree: [], // 机构树
            isRescourceShow: 0,
            tempTableChekbox: ["序号","所属机构", "所属模块","萤石云key","萤石云secret","序列","通道","操作"],
            tableChekbox: ["序号", "所属机构","所属模块","萤石云key","萤石云secret","序列","通道","操作"],
            // 表格信息
            tableData: [],
            // 新增表单数据
            addForm: {},
            options:[
                // {
                //     value: '1',
                //     label: '监管平台',
                //     children:[{
                //         value:"2",
                //         label:" 监管地图"
                //     },
                //     {
                //         value:"3",
                //         label:" 消防安全"
                //     }]
                // },
                {
                    value: '4',
                    label: '客服中心',
                    children:[
                        {
                            value:"5",
                            label:"话务监管"
                        }
                    ]
                },
                {
                    value: '6',
                    label: '客服中心可视化',
                    children:[{
                        value:"7",
                        label:"社区养老"
                    },
                    {
                        value:"8",
                        label:"机构养老"
                    }]
                },
                {
                    value: '10',
                    label: '就餐信息可视化',
                },
                {
                    value: '11',
                    label: '机构养老一张图',
                },
            ]
        }
    },
    created() {
        this.showList()
        this.getOrgTree()
    },
    inject: ["reload"], //注入
    mounted() {},
    methods: {
        submit() {
            let url = ""
            if (this.addForm.id) {
               url = "ypt/admin/monitorManagement/info/save"
                
            } else {
               url = "ypt/admin/monitorManagement/info/save"
            }
            this.$http
                .request({
                    url: url,
                    method: "POST",
                    data: {
                        ...this.addForm,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        this.showList()
                        this.dialogVisible = false
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        dialogVisibleClone() {
            this.dialogVisible = false
            this.addForm={}
            this.$refs.addformRef.resetFields()
        },
        send() {
            this.$refs["addformRef"].validate((valid) => {
                if (valid) {
                    this.submit()
                } else {
                    this.$message.error("请按照提示正确输入")
                    return false
                }
            })
        },
        showList() {
            let params = {
                pageNo: this.query.pageNo,
                pageSize: this.query.pageSize,
                ...this.queryInfo,
            }
            this.$http
                .request({
                    url: "/ypt/admin/monitorManagement/info/findList",
                    method: "POST",
                    data: params,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.tableData = []
                            this.total = 0
                            return
                        }
                        this.tableData = res.content.list
                        this.total = res.content.count
                    }
                })
        },
        // 页面刷新
        Reset() {
            let params = {
                pageNo: this.query.pageNo,
                pageSize: this.query.pageSize,
                type: "1",
            }
            this.$http
                .request({
                    url: "/ypt/admin/monitorManagement/info/findList",
                    method: "POST",
                    data: params,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.tableData = []
                            this.total = 0
                            return
                        }
                        this.tableData = res.content.list
                        this.total = res.content.count
                    }
                })
        },
        //table列checkbox发生变化
        tableChekboxChange(val) {
            this.tempTableChekbox = val.map((item) => item)
        },
        // 查询信息
        QuerySearch() {
            // this.query.pageNo = 1
            this.showList()
        },
        // 打开新增弹框
        showDialog(title, row) {
            this.dialogTitle = title
            this.dialogVisible = true
            switch (title) {
                case "新增":
                    this.addForm={}
                    break
                case "查看":
                    break
                case "编辑":
                    break
            }
            if (title != "新增") {
                this.$http
                    .request({
                        url: "ypt/admin/monitorManagement/info/get",
                        method: "POST",
                        data: {
                            id: row.id,
                        },
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            this.addForm = res.content
                            this.addForm.orgId = String(this.addForm.orgId)
                            return
                        }
                        this.$message({
                            message: "根据ID获取信息失败",
                            type: "error",
                        })
                    })
            }
        },
        // 分页
        handleSizeChange(val) {
            this.query.pageSize = val
            this.showList()
            console.log(`每页 ${val} 条`)
        },
        handleCurrentChange(val) {
            this.query.pageNo = val
            this.showList()
            console.log(`当前页: ${val}`)
        },
        // 删除
        async deleteItem(row) {
            const confirm = await this.$confirm(
                "此操作将永久删除该信息, 是否继续?",
                "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }
            ).catch((err) => err)
            console.log(confirm)
            if (confirm === "confirm") {
                request({
                    url: "/ypt/admin/monitorManagement/info/delete",
                    method: "POST",
                    data: {
                        id: row.id,
                        type: "1",
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        this.showList()
                        this.$message({
                            message: "删除成功",
                            type: "success",
                        })
                        return
                    }
                    this.$message({
                        message: "删除失败",
                        type: "error",
                    })
                })
            } else {
                this.$message({
                    message: "取消删除",
                    type: "info",
                })
            }
        },
        //table列checkbox发生变化
        tableChekboxChange(val) {
            this.tempTableChekbox = val.map((item) => item)
        },
        // 获取机构树
        async getOrgTree() {
            // const { content } = await post(
            //     "/rbac/admin/org/info/OrgTreeForOrgIdlist",
            //     {
            //         isValid: 1,
            //     }
            // )
            // this.orgTree = content;
            this.$post("/rbac/admin/org/info/OrgTreelist", { isValid: 1 }).then(
                (res) => {
                    if (res.code === 200) {
                        //当前账号绑定的机构所有下级
                        let treeList = []
                        this.orgTree = this.chbehavior(
                            res.content,
                            this.$store.state.info.orgId
                        )
                        if (!this.orgTree.children) {
                            //当前账号绑定的机构下级&自己数据
                            treeList.push({
                                label: this.orgTree.label,
                                orgId: this.orgTree.orgId,
                            })
                            this.orgTree = treeList
                        } else {
                            treeList.push({
                                label: this.orgTree.label,
                                orgId: this.orgTree.orgId,
                                children: this.orgTree.children,
                            })
                            this.orgTree = treeList
                        }
                    }
                }
            )
        },
        chbehavior(arr, id) {
            let res
            ;(function deepId(arr, id) {
                for (let a of arr) {
                    if (a.orgId == id) {
                        res = a
                    } else if (a.children && !res) {
                        deepId(a.children, id)
                    }
                }
            })(arr, id)
            return res
        },
        flagChang(val){
            console.log(val);
        }
    },
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog__header {
    border-bottom: 1px solid #ccc;
}

.btn_group {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
}

.btnSite {
    display: flex;
    justify-content: center;
}
</style>
